import { Money } from "types/landlord/reports";
import {
  VerificationSchema,
  Template
} from "types/landlord/verificationTemplate";
import { Asset } from "shared/app/IdentityVerificationReport/types";
import { CriteriaRentType } from "shared/types";

export interface TemplateResponse {
  verification_template: Template;
}

export interface VerificationSchemasResponse {
  verification_schemas: VerificationSchema[];
}

export interface GetTemplatesResponse {
  object: string;
  current_page: number;
  extra: null | any;
  has_more: boolean;
  items: Template[];
  page_count: number;
  total_count: number;
}

export enum UnlistUnitTiming {
  NEVER = "never",
  ON_FIRST_APPLICATION = "on_first_application",
  ON_APPROVE = "on_approve"
}

export enum AdverseActionLetterType {
  Generic = "generic",
  Washington = "washington"
}

export interface AdverseActionLetterSignature extends Asset {
  value: string;
}

export interface TemplateSettings {
  automatically_unlist_unit_timing: UnlistUnitTiming;
  notify_applicants: boolean;
  display_rent_amount: boolean;
  display_available_date: boolean;
  has_pet_rent: boolean;
  has_voucher: boolean;
  pet_rent_value?: Money;
  has_move_in_date_limit: boolean;
  max_move_in_days?: number;
  auto_approve_enabled?: boolean;
  auto_approve_delay?: number;
  auto_approve_delay_enabled?: boolean;
  auto_approve_delay_type?: string;
  auto_approve_delay_value?: number;
  adverse_action_letter_type: AdverseActionLetterType;
  adverse_action_letter_signature?: {
    svg?: AdverseActionLetterSignature | string;
    png?: AdverseActionLetterSignature | string;
  };
  adverse_action_letter_address?: {
    street_address?: string;
    apartment_address?: string;
    city?: string;
    state?: string;
    postal_code?: string;
  };
  criteria_rent_type?: CriteriaRentType;
}

export interface Additional {
  page: number;
  propertyId: number;
}
